import styled from "styled-components";

export const NavLink = styled.div`
  text-decoration: none;
  color: black;
`;
export const NavBar = styled.nav`
  padding: 0;
  line-height: 22px;
  margin-right: -21px;
`;

export const NavItem = styled.span`
  font-size: 16px;
  margin-right: 10px;
  padding-right: 13px;
  display: inline-block;
  padding-bottom: 15px;
  position: relative;
  font-weight: normal;
  cursor: pointer;
`;
